import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { auth } from "./firebase";
import { AuthProvider } from "./context/AuthContext";
import ProtectedAdminRoute from "./routes/ProtectedAdminRoute";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Home from "./pages/Home";
import MovieDetail from "./pages/MovieDetails";
import SocialPage from "./pages/Social";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Contact from "./pages/Contact";
import AdminLogin from "./components/admin/AdminLogin";
import AdminSignup from "./components/admin/AdminSignup";
import MoviesPage from "./pages/MoviesPage";
import Profile from "./pages/Profile";
import AdminHome from "./pages/AdminHome";
import './style.css';
import Users from "./pages/Users";
import Requests from "./pages/Requests";
import AdminMovies from "./pages/AdminMovies";
import MovieList from "./components/admin/MovieList";
import EditMovie from "./pages/EditMovie";
import AddMovie from "./pages/AddMovie";
import InvestPage from "./pages/Invest"; // Import the new InvestPage

const theme = createTheme({
  palette: {
    primary: {
      main: "#7d1aed",
    },
    secondary: {
      main: "#ff4081",
    },
  },
});

function App() {
  const [movies, setMovies] = useState([
    {
      id: 1,
      name: 'Stree 2: Sarkate Ka Aatank',
      genre: 'Horror',
      image: 'https://cinevest.vercel.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fgaadhaar-7ff3f.appspot.com%2Fo%2Fposters%252F1728662935702_MV5BZTEyYzVjYjEtNWYzZi00NWRhLTgyZjUtNDlkZjBiNWIxYTEwXkEyXkFqcGc%2540._V1_.jpg%3Falt%3Dmedia%26token%3Db86c445e-6b3b-43ba-b5b9-7e3a19b8c003&w=384&q=75',
      currentFunding: 285000, // ₹28,50,000
      targetFunding: 5000000, // ₹50,00,000
      availableUnits: 249975,
      description: 'A horror movie about a ghost haunting a small town.',
      director: 'Amar Kaushik',
      cast: ['Rajkummar Rao', 'Shraddha Kapoor'],
      crew: ['Dinesh Vijan', 'Raj Nidimoru', 'Krishna D.K.'],
      releaseDate: 'Aug 15th',
    },
    {
      id: 2,
      name: 'Deadpool & Wolverine',
      genre: 'Sci-Fi',
      image: 'https://cinevest.vercel.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fgaadhaar-7ff3f.appspot.com%2Fo%2Fposters%252F1728663027256_deadpoolandwolverine_lob_crd_03.jpg%3Falt%3Dmedia%26token%3D4f5e0200-d588-4fed-bd1c-711fbed95b12&w=384&q=75',
      currentFunding: 10000, // ₹10,000
      targetFunding: 10000000, // ₹1,00,00,000
      availableUnits: 499995,
      description: 'A sci-fi movie featuring Deadpool and Wolverine teaming up.',
      director: 'Shawn Levy',
      cast: ['Ryan Reynolds', 'Hugh Jackman'],
      crew: ['Kevin Feige', 'Simon Kinberg'],
      releaseDate: 'July 26',
    },
    {
      id: 3,
      name: 'Joker: Folie à Deux',
      genre: 'Action',
      image: 'https://cinevest.vercel.app/_next/image?url=https%3A%2F%2Ffirebasestorage.googleapis.com%2Fv0%2Fb%2Fgaadhaar-7ff3f.appspot.com%2Fo%2Fposters%252F1728725362909_medium-joker-movie-poster-for-room-office-13-inch-x-19-inch-original-imafk9kg4hczamuz.webp%3Falt%3Dmedia%26token%3D38f922ca-4d0e-4c84-b131-3e021e09dbd6&w=384&q=75',
      currentFunding: 1000, // ₹1,000
      targetFunding: 10000000, // ₹1,00,00,000
      availableUnits: 499995,
      description: 'An action-packed sequel to the Joker movie.',
      director: 'Todd Phillips',
      cast: ['Joaquin Phoenix', 'Lady Gaga'],
      crew: ['Bradley Cooper', 'Emma Tillinger Koskoff'],
      releaseDate: 'Only in Theaters',
    },
  ]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsAuthenticated(!!user);
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
          <div className="App">
            <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/movie/:id" element={<MovieDetail movies={movies} />} />
              <Route path="/invest/:id" element={<InvestPage movies={movies} />} /> {/* Add InvestPage route */}
              <Route path="/social" element={<SocialPage />} />
              <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/movie" element={<MoviesPage />} />
              <Route path="/profile" element={<Profile />} />

              {/* Admin Authentication */}
              <Route path="/admin/login" element={<AdminLogin setIsAuthenticated={setIsAuthenticated} />} />
              <Route path="/admin/signup" element={<AdminSignup setIsAuthenticated={setIsAuthenticated} />} />

              {/* Protected Admin Route */}
              <Route element={<ProtectedAdminRoute />}>
                <Route path="/admin/home" element={<AdminHome />}>
                  <Route path="users" element={<Users />} />
                  <Route path="requests" element={<MovieList />} />
                  <Route path="movies" element={<AdminMovies />} />
                </Route>
              </Route>

              {/* Other Routes */}
              <Route path="/edit/:id" element={<EditMovie />} />
              <Route path="/add-movie" element={<AddMovie />} />
            </Routes>
            <Footer />
          </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;